var moduleMap = {
	"App": function() {
		return Promise.all([__webpack_require__.e(164), __webpack_require__.e(466), __webpack_require__.e(792), __webpack_require__.e(416), __webpack_require__.e(653), __webpack_require__.e(706), __webpack_require__.e(140), __webpack_require__.e(51), __webpack_require__.e(101), __webpack_require__.e(478), __webpack_require__.e(310), __webpack_require__.e(171), __webpack_require__.e(108)]).then(function() { return function() { return (__webpack_require__(3465)); }; });
	},
	"FlexiPayApplicationNavigationItem": function() {
		return Promise.all([__webpack_require__.e(164), __webpack_require__.e(466), __webpack_require__.e(416), __webpack_require__.e(140), __webpack_require__.e(623)]).then(function() { return function() { return (__webpack_require__(2623)); }; });
	},
	"NoticeBanner": function() {
		return Promise.all([__webpack_require__.e(164), __webpack_require__.e(466), __webpack_require__.e(416), __webpack_require__.e(140), __webpack_require__.e(101), __webpack_require__.e(137)]).then(function() { return function() { return (__webpack_require__(137)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});